import Vue from 'vue'
import Vuex from 'vuex'

import Project from './modules/project'
import Activity from './modules/activity'
import Dynamic from './modules/dynamic'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Project: Project, //公益项目相关
    Activity: Activity, //公益活动相关
    Dynamic: Dynamic //动态相关
  }
})
